export default "__VITE_ASSET__OZ4xRGBz__"